<script lang="ts">
  const { down = false } = $props();
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class="feather feather-chevron-up"
  style:transform="rotate({down ? 180 : 0}deg)"
>
  <polyline points="18 15 12 9 6 15"></polyline>
</svg>
